var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifying-glass",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.327,
    height: 31.328,
    viewBox: "0 0 31.327 31.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M42.925,38.929,37.333,33.35a.6.6,0,0,0-.091-.069,13.567,13.567,0,0,1-1.781,2.185,13.327,13.327,0,0,1-2.194,1.783c.028.029.048.063.076.09l5.581,5.591a2.829,2.829,0,0,0,4-4Z",
    transform: "translate(-12.424 -12.429)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M22.24,3.809a13.032,13.032,0,1,0,0,18.431A13.044,13.044,0,0,0,22.24,3.809ZM6.206,19.848a9.647,9.647,0,1,1,13.642,0A9.657,9.657,0,0,1,6.206,19.848Z",
    transform: "translate(0 0)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M12.461,21.09c-.276-1.135-1.414-2.71-2.371-2.209-.759.387-.545,2.163-.187,3.213,1.6,4.775,7.414,5.784,8.019,5.18S13.556,25.583,12.461,21.09Z",
    transform: "translate(-3.577 -7.015)",
    fill: "#4397d2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.5c275e07c107482a5124a617e8b64de8.svg";
export { ForwardRef as ReactComponent };